import * as React from "react";
import { Column } from "react-table";

import { ITableProps } from "src/library/components/Tables/Table";
import { ButtonLink } from "src/library/components/Link";
import * as globalTableColumns from "src/core/shared/components/TableGlobalColumns";
import { IProcessJobError } from "src/core/process-job/api/processJobs.api";

export type IOrderImportErrorsColumns = Partial<ITableProps>;

export const orderExportErrorsTableColumns = (): Array<Column<IProcessJobError<"order-export">>> => [
  globalTableColumns.id(),
  globalTableColumns.standardText({
    Header: "Message",
    accessor: "message",
    multiLine: true,
    width: 300
  }),
  globalTableColumns.actions({
    cell: row => (
      <ButtonLink
        className="orders-button"
        to={`/orders/${(row.original as IProcessJobError<"order-export">).data?.orderId}`}
      >
        View Order
      </ButtonLink>
    ),
    width: 200
  })
];
